G.BoardDirtS = function(board) {
  G.BoardLayer.call(this, board, {
    constructor: G.DirtS,
    maxHp: 3,
    hpToken: true,
    editorSymbol: "dS",
    collectableType: "dirtS",
  });

  this.decreasedToken = false;

  G.sb("hitDirtS").add(function(type) {
    this.decreasedToken = true;
  }, this);

  G.sb("actionQueueEmptyAfterMove").add(function() {
    if (!this.decreasedToken) {
      this.spread();
    }
    this.decreasedToken = false;
  }, this);
};

G.BoardDirtS.prototype = Object.create(G.BoardLayer.prototype);

G.BoardDirtS.prototype.spread = function() {
  var actions = ["U", "D", "L", "R", "I"];
  var len = this.children.length;
  var iRnd = game.rnd.between(0, len-1);

  for (var i = 0; i < len; i++) {
    var dirt = this.children[(i+iRnd)%len];

    Phaser.ArrayUtils.shuffle(actions);
    for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
      var action = actions[actionIndex];

      switch (action) {
        case "U":
          if (this.isSpreadPossible(dirt.cellX, dirt.cellY-1)) {
            this.spreadToken(dirt.cellX, dirt.cellY-1);
            return;
          }
          break;
        case "D": 
          if (this.isSpreadPossible(dirt.cellX, dirt.cellY+1)) {
            this.spreadToken(dirt.cellX, dirt.cellY+1);
            return;
          }
          break;
        case "L": 
          if (this.isSpreadPossible(dirt.cellX-1, dirt.cellY)) {
            this.spreadToken(dirt.cellX-1, dirt.cellY);
            return;
          }
          break;
        case "R": 
          if (this.isSpreadPossible(dirt.cellX+1, dirt.cellY)) {
            this.spreadToken(dirt.cellX+1, dirt.cellY);
            return;
          }
          break;
        // case "I": 
        //   if (dirt.hp < this.config.maxHp) {
        //     dirt.increaseHp();
        //     return;
        //   }
        //   break;
      }
    }
  }
};

G.BoardDirtS.prototype.isSpreadPossible = function(cellX,cellY) {
  // normal waffle check
  var noWaffle = true;
  if (this.board.boardDirt && this.board.boardDirt.isToken(cellX, cellY)) {
    noWaffle = false;
  } 

  var noIce = true;
  if (this.board.boardIce && this.board.boardIce.isToken(cellX, cellY)) {
    noIce = false;
  } 

  var noRock = true;
  if (this.board.boardCage && this.board.boardCage.isToken(cellX, cellY)) {
    noRock = false;
  } 

  return this.board.isCellOnBoard(cellX, cellY)
    && !this.getToken(cellX, cellY)
    && noWaffle
    && noRock
    && noIce;
};

G.BoardDirtS.prototype.spreadToken = function(cellX, cellY) {
  G.sb("onCollectableAdded").dispatch("dirtS");
  var token = this.createToken(cellX, cellY, 1);
  game.add.tween(token.scale)
    .from({x: 0, y: 0}, 500, Phaser.Easing.Sinusoidal.Out, true);
};